import { configureStore } from '@reduxjs/toolkit';
import carListingReducer from '../features/carListing/carListingSlice';
import credReducer from '../features/cred/credSlice';
import userReducer from '../features/user/userSlice';
import depositeAmountReducer from '../features/depositeAmount/depositeAmountSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import priceRangeReducer from '../features/priceRange/priceRangeSlice';
import blogReducer from '../features/blog/blogSlice';

export const store = configureStore({
  reducer: {
    cred: credReducer,
    carListing: carListingReducer,
    depositeAmount: depositeAmountReducer,
    user: userReducer,
    dashboard: dashboardReducer,
    priceRange: priceRangeReducer,
    blog: blogReducer,
  },
}); 
